import { post } from "helpers/api_helper"
import { getNfComments } from "services/quickblox"

export const getInitials = name => {
  if (!name) return 0
  const words = name?.trim()?.match(/\b\w+\b/g)
  const initials = words?.slice(0, 2)?.map(word => word[0]?.toUpperCase())
  return initials?.join("")
}

export const formatDate = date => {
  if (date === 0 || isNaN(new Date(date).getTime())) {
    return ""
  }
  const options = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }
  // Use en-US locale and manipulate the output to match month/day/year format
  const formattedDate = new Date(date).toLocaleString("en-US", options)
  // Check if the formattedDate is "Invalid Date"
  if (formattedDate === "Invalid Date") {
    return "Null"
  }
  const parts = formattedDate.split(", ")
  const [month, day, year] = parts[0].split("/")
  const time = parts[1]
  return `${month}/${day}/${year}, ${time}`
}

export const getCommentForEachMessage = async (messageId, messageIndex) => {
  try {
    let filter = {
      parent_message_id: {
        in: [messageId],
      },
    }
    let comments = await getNfComments(filter)
    const user_ids_comments = [
      ...new Set(
        comments?.map(comment => comment?.sender_id).filter(id => id !== null)
      ),
    ]

    let data = []
    if (user_ids_comments.length > 0) {
      const resp = await post(`/get-users`, { user_ids: user_ids_comments })
      data = comments?.map(comment => {
        return {
          ...comment,
          profile: resp?.data?.filter(
            user => user?.id === comment?.sender_id
          )[0],
        }
      })
    } else {
      console.log("No user IDs found for fetching profile data.")
    }
    return data
  } catch (err) {}
}

export const handleDateAndTime = date => {
  if (+date === 0 || isNaN(new Date(+date).getTime())) {
    return ""
  }
  const options = {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }
  // Use en-US locale and manipulate the output to match month/day/year format
  const formattedDate = new Date(+date).toLocaleString("en-US", options)
  // Check if the formattedDate is "Invalid Date"
  if (formattedDate === "Invalid Date") {
    return "Null"
  }
  const parts = formattedDate.split(", ")
  const [month, day, year] = parts[0].split("/")
  const time = parts[1]
  return `${month}/${day}/${year}, ${time}`
}

export const renderUserProfileIcon = user => {
  return (
    <span className="group-avatar">
      {user?.profile_pic?.file?.url ? (
        <img
          src={user?.profile_pic?.file?.url}
          alt="Icon"
          className="icon-image"
        />
      ) : (
        <div className="initial-character video-call-in chat-box-in">
          {getInitials(`${user?.first_name} ${user?.last_name}`)}
        </div>
      )}
    </span>
  )
}

export const sortDialogsByDate = (a, b) => {
  const aDate = a?.last_message_date_sent
    ? new Date(a?.last_message_date_sent * 1000)
    : new Date(a?.created_at)
  const bDate = b?.last_message_date_sent
    ? new Date(b?.last_message_date_sent * 1000)
    : new Date(b?.created_at)
  if (aDate > bDate) {
    return -1
  }
  if (aDate < bDate) {
    return 1
  }

  return 0
}
